import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";

export default function DonorCowsPage() {
  const [items, setItems] = useState([]);
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    document.title = "The Females — Bulls of the Big Sky";
    (async () => {
      const [r, s] = await Promise.all([api.get("/donor-cows"), api.get("/site-settings")]);
      setItems(r.data);
      setSettings(s.data);
    })();
  }, []);

  return (
    <div data-testid="donor-cows-page" className="min-h-screen" style={{ background: "var(--bg-primary)" }}>
      <SiteHeader />
      <section className="pt-40 pb-12 px-6 md:px-12">
        <div className="max-w-[1400px] mx-auto">
          <div className="eyebrow">The Foundation</div>
          <h1 className="font-display text-6xl md:text-8xl lg:text-9xl mt-4 leading-[0.95]">
            The females.
          </h1>
          <p className="mt-8 max-w-3xl text-base md:text-lg" style={{ color: "var(--text-secondary)" }}>
            Every program is dependent upon a strong foundation, and every bull sold is built upon breed
            leading cow power. These are some of the elite dams behind the Bulls of the Big Sky — the
            cows whose genetics advance the breed and the industry forward.
          </p>
        </div>
      </section>

      <section className="px-6 md:px-12 pb-32">
        <div className="max-w-[1400px] mx-auto">
          {items.length === 0 ? (
            <div className="border p-16 text-center mt-12" style={{ borderColor: "var(--border-subtle)" }}>
              <div className="font-display text-3xl mb-3">Donor Directory Coming Soon</div>
              <Link to="/" className="link-brass mt-6 inline-block">Back to home →</Link>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
              {items.map((c, i) => (
                <article key={c.id} data-testid={`donor-${i}`} className="border" style={{ borderColor: "var(--border-subtle)" }}>
                  {c.photo_url && (
                    <div className="frame-image" style={{ aspectRatio: "4 / 3" }}>
                      <img src={c.photo_url} alt={c.name} className="w-full h-full object-cover" />
                    </div>
                  )}
                  <div className="p-6">
                    <div className="eyebrow text-[10px] mb-2" style={{ color: "var(--brass-bright)" }}>
                      {c.breed || "SimGenetics"}  {c.owner && `•  ${c.owner}`}
                    </div>
                    <h2 className="font-display text-2xl md:text-3xl leading-tight">{c.name}</h2>
                    {c.registration && (
                      <div className="text-xs mt-1" style={{ color: "var(--text-muted)" }}>
                        ASA #{c.registration}
                      </div>
                    )}
                    {c.description && (
                      <p className="mt-3 text-sm leading-relaxed" style={{ color: "var(--text-secondary)" }}>
                        {c.description}
                      </p>
                    )}
                    <dl className="mt-5 space-y-2 text-xs">
                      {c.sire && <Pair k="Sire" v={c.sire} />}
                      {c.dam && <Pair k="Dam" v={c.dam} />}
                      {c.notable_progeny && <Pair k="Progeny" v={c.notable_progeny} />}
                    </dl>
                  </div>
                </article>
              ))}
            </div>
          )}
        </div>
      </section>

      <SiteFooter settings={settings} />
    </div>
  );
}

function Pair({ k, v }) {
  return (
    <div className="flex gap-3">
      <dt className="eyebrow-muted text-[10px] w-16 shrink-0">{k}</dt>
      <dd style={{ color: "var(--text-primary)" }}>{v}</dd>
    </div>
  );
}
